import React, { useState, useEffect, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {
  MdMenu,
  MdKeyboardArrowDown,
  MdShoppingCart,
  MdPersonOutline,
  MdPersonAdd,
  MdStore,
  MdLockOutline,
  MdList,
  MdExitToApp,
  MdLocationOn,
  MdKeyboardBackspace,
  MdContactPhone,
  MdSettings,
} from "react-icons/md";
import { BiSearch } from "react-icons/bi";
import { AiFillDownCircle } from "react-icons/ai";
import Popover, { ArrowContainer } from "react-tiny-popover";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import Button from "../Button";
import { primaryColor } from "../../constants"; // , headerBackground, colorParagraph, colorDetail, colorTitle, buttonSecondaryBackground, buttonSecondaryText, buttonPrimaryBackgound, buttonPrimaryText, bodyBackgroundDetails, bodyBackgroundGeneral, imgLogo
import {
  userSelector,
  fcmTokenSelector,
  tokenSelector,
} from "../../ducks/access/selectors";
import { logout } from "../../ducks/access/actions";
import { getLocalitiesInit, openCartModal } from "../../ducks/general/actions";
import {
  selectedLocalitySelector,
  localitiesSelector,
} from "../../ducks/general/selectors";
import Drawer from "../Drawer";
import CartModal from "../CartModal";
import { cartSelector, themeSelector } from "../../ducks/shopping/selectors";
import { getLocalityStoresInit } from "../../ducks/shopping/actions";
import { setShowManagerForm } from "../../ducks/store/actions";
import LocationModal from "../LocationModal";
import StoreManagerForm from "../StoreManagerForm";
import Input from "../Input";

const WrapGlassSearch = styled.div`
    position: absolute;
    top: 0px;
    right: 0px;
    background-color: ${(props) => props.bgColor || "#693179"};
    height: 32px;
    width: 50px;
    border-radius: 0px 8px 8px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    @media (max-width: 480px) {
    width: 31px;
    }
  `;
    const WrapGlassSearchRespo = styled.div`
    position: absolute;
    top: 0px;
    right: 0px;
    background-color: ${(props) => props.bgColor || "#693179"};
    height: 32px;
    width: 50px;
    border-radius: 0px 8px 8px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    @media (max-width: 480px) {
    width: 31px;
    }
  `;

const WrapSearchBar = styled.div`
display: block;
    position: relative;
   @media (min-width: 1151px) {
   width: 600px;
  }
  @media (max-width: 1150px) {
    width: 350px;
  }
  @media (max-width: 920px) {
    width: 280px;
  }
  @media (max-width: 752px) {
    display: none;
  }
  @media (max-width: 580px) {
    width: 45%;
  }
  `;
  const WrapSearchBarRespo = styled.div`
  position: relative;
 width: 100%;
`;

const SearchBar = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: ${(props) => props.bottom || "20px"};
    justify-content:center; // // // / //
  `;
const Container = styled.div`
  margin-top: ${(props) => props.marginTop || "0px"}; // express //
  width: calc(100% - 60px);
  padding: 0px 20px 0px 40px;
  height: 70px;
  background-color: ${(props) => props.bgColor || "#ffffffeb"}; // express //
  box-shadow: 0px 5px 5px 0px #80808080;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1;
  @media (max-width: 768px) {
   margin-top: 0px;
  }

  @media (max-width: 420px) {
    height: 60px;
    width: calc(100% - 20px);
    padding: 0px 10px;
  }
`;
const ContainerRespo = styled.div`
  width: auto;
  padding: 0px 10px 0px 10px;
  height: ${(props) => props.height || "32px"};
  background-color: ${(props) => props.bgColor || "#ffffffeb"}; // express //
  box-shadow: 0px 5px 5px 0px #80808080;
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 1;
  @media (max-width: 752px) {
  display: flex;
  }
`;

const Logo = styled.img`
  height: 30px;
  margin-top: 10px;
  cursor: pointer;
  @media (max-width: 420px) {
    height: 30px;
  }
`;

const BackButton = styled.div`
  height: 35px;
  width: 35px;
  box-shadow: 0px 0px 5px ${(props) => props.boxShadow || "#80808080"};
  border-radius: 20px;
  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.bgColor || "#fff"};
  transition-duration: 0.3s;
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.bgColorHover || "#80808080"};
  }
`;

const RightContainer = styled.div`
  display: flex;
  margin-right: 20px;
  align-items: center;
  @media (max-width: 768px) {
    margin-right: 0px;
  }
`;

const Username = styled.p`
  font-weight: bold;
  color: ${(props) => props.color || "#404040"}; // express //
  margin-right: 3px;
  font-size: 14px;
  min-width: 120px;
  text-align: center;
  @media (max-width: 768px) {
    display: none;
  }
`;

const CartButton = styled.div`
  position: relative;
  background-color: ${(props) => props.bgColor || "#b1bbcd"}; // express //
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  border-radius: 25px;
  width: 50px;
  height: 50px;
  div.badge {
    position: absolute;
    right: -2px;
    top: -2px;
    width: 14px;
    height: 14px;
    background-color: ${(props) => props.bgColorBadge || primaryColor}; // express //

    color: ${(props) => props.colorBadge || "#fff"};
    font-size: 12px;
    border-radius: 10px;
    padding: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media (max-width: 768px) {
    height: 36px;
    width: 36px;
    margin-right: 10px;
    div.badge {
      font-size: 10px;
      width: 12px;
      height: 12px;
      right: -4px;
      top: -3px;
    }
  }
`;

const UserMenuContainer = styled.div` // user && user.commerce ?
  background-color: ${(props) => props.bgColor || "#fafafa"}; // express //
  box-shadow: 1px -1px 10px ${(props) => props.boxShadow || "#80808080"};
  margin: 0px 10px 10px 10px;
  padding: 16px;
  border-radius: 20px;
  width: 320px;
  p {
    font-weight: 500;
    font-size: 18px;
    color: #3c434d;
    margin-left: 10px;
    margin-bottom: 10px;
  }
  div.divider {
    height: 1px;
    background-color: #e0e0e0;
    margin-bottom: 10px;
  }
  @media (max-width: 420px) {
    width: 280px;
  }
`;

const LocalityContainer = styled.div`
  display: flex;
  align-items: center;
  padding-right: 20px;
  div {
    margin-right: 20px;
  }
  p.locality {
    font-size: 14px;
    color: #3c434d;
    margin-bottom: -3px;
  }
  p {
    font-size: 12px;
    font-weight: 300;
    color: #757a87;
  }
  img {
    width: 20px;
    height: 20px;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

const DrawerContainer = styled.div`
  p {
    font-weight: bold;
    color: #404040;
    margin: 10px 20px 10px 20px;
    font-size: 14px;
  }
  div.divider {
    height: 1px;
    background-color: #eaeaea;
    margin: 10px 0px;
  }
`;

const ComunaText = styled.p`
  font-size: 13px;
  color: ${(props) => props.color || "#000000"}; // express //
  @media (max-width: 768px) {
    display: none;
  }
`;
const Header = ({ canGoBack, canSearchHeader, idStoreDetail, catCatView, subCatCatView, famCatView, marginTopHeader}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const theme = useSelector(themeSelector);
  const user = useSelector(userSelector);
  const fcmToken = useSelector(fcmTokenSelector);
  const token = useSelector(tokenSelector);
  const selectedLocality = useSelector(selectedLocalitySelector);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [openLocationModal, setOpenLocationModal] = useState(false);
  const [openResponsiveMenu, setOpenResponsiveMenu] = useState(false);
  const localities = useSelector(localitiesSelector);
  const initialLocalities = useRef(localities);

  const cart = useSelector(cartSelector);

  const params = new URLSearchParams(history && history.location && history.location.search);

  const [searchText, setSearchText] = useState(
     params.has("search") ? params.get("search") : "" // ("search")
  );

  useEffect(() => {
    if (!initialLocalities.current || initialLocalities.current.length === 0)
      dispatch(getLocalitiesInit());
  }, [dispatch]);

  const handleLogout = () => {
    // Google Analytics
    if(process.env.REACT_APP_ENABLE_ANALYTICS_EVENTS==="true") {
    window.gtag('event', 'click', {
      'event_category': 'Header',
      'event_label': 'Cerrar sesion'
    });
  }

    dispatch(logout(fcmToken, token));
  };

  const cartCount = useMemo(() => {
    if (!Array.isArray(cart)) return 0;
    let count = 0;
    cart.forEach((item) => {
      count += item.ordenItems.length;
    });
    return count;
  }, [cart]);
  const handleClickStore = () => {
     // Google Analytics
     if(process.env.REACT_APP_ENABLE_ANALYTICS_EVENTS==="true") {
     window.gtag('event', 'click', {
      'event_category': 'Header',
      'event_label': 'Boton ir a /brands'
    });
  }

    dispatch({ type: "SET_SELECTED_LOCALITY", payload: undefined });  // ???
    dispatch(getLocalityStoresInit()); // ???
    history.push("/brands");  // ???
  };

  const gtagCartModal = () => {
    // Google Analytics
    if(process.env.REACT_APP_ENABLE_ANALYTICS_EVENTS==="true") {
    window.gtag('event', 'click', {
      'event_category': 'Header',
      'event_label': 'Boton abrir Carrito Compra'
    });
  }
  };
  
  const handleSearch = () => {
    if(searchText.trim() !== "") {
      const query = `${
        searchText.trim()
          ? `&search=${                   //  ? `&search=${
          //   parseInt(searchText, 10)
          //   ? parseInt(searchText, 10)
          //   : encodeURI(searchText)

          searchText.trim() // Just the input string...to dont having problems with SKU
            }`
          : ""
        }`;

        // depends on current location path will be go to another:
        if (history && history.location && history.location.pathname.includes("/catalog")) { // is in /catalog ? tiendas express de una brand !!!!
          history.push(`/products-gral/1?${query}`);  // gral products // express brand specific there
        } 
        if (history && history.location && history.location.pathname.includes("/store-detail")) { // is in /store-detail ?
          history.replace(`/store-detail/${idStoreDetail}/1?${query}`);  // replace  // with prop from match params storeDetail
        } 
        if (history && history.location && history.location.pathname.includes("/category-view")) { // is in /category-view ?
          history.replace(`/category-view/${catCatView}/${subCatCatView}/${famCatView}?${query}${theme && theme.id ? `&brand=${theme.id}` : ""}`);  // replace // with props from match params categoryView
        } 
        if (history && history.location && history.location.pathname.includes("/products-gral")) { // is in /products-gral ?
          history.replace(`/products-gral/1?${query}`);  // replace in products-gral 
        }

        // Google Analytics
        if(process.env.REACT_APP_ENABLE_ANALYTICS_EVENTS==="true") {
          window.gtag('event', 'click', {
          'event_category': 'Header',
          'event_label': 'Busqueda general de productos'
          });
        }
 
    }
  };
  return (
    <div>
    <Container bgColor="white" marginTop={marginTopHeader}>
      <div className="row-cont">
        {canGoBack && history.length > 2 ? (
          <BackButton onClick={history.goBack} boxShadow={theme && theme.colorTitle} bgColor="white" bgColorHover={theme && theme.bodyBackgroundGeneral}>
            <MdKeyboardBackspace size={20} color={theme && theme.colorTitle || "#000"} />
          </BackButton>
        ) : null}
        <Link to={history.location.pathname !== "/" ? "/brands" : "/"}>
          <Logo
            src={theme && theme.imgLogo || "/assets/images/yoper-header.png"} // 
            alt={`${theme && theme.name || "logo"}`}
            onClick={handleClickStore}
          />
        </Link>
      </div>

      {canSearchHeader ?
        <WrapSearchBar>
        <SearchBar bottom="0px">
          <Input
            value={searchText}
            onChange={({ target: { value } }) => setSearchText(value)} // setSearchText(value)
            placeholder="Buscar productos"
            width="100%"
            widthXs="calc(100% - 20px)"
            height="30px"
            onKeyPress={(e) => e.key==="Enter" ? handleSearch() : null}
          />
        
        </SearchBar>

        <WrapGlassSearch onClick={handleSearch} bgColor={theme && theme.buttonPrimaryBackgound}>
          <BiSearch size={20} color={theme && theme.buttonPrimaryText || "white"} className="opacity"/>        
        </WrapGlassSearch>
      </WrapSearchBar>
      : null}

      <RightContainer>
        {selectedLocality && !user.commerce ? (
          <div>
            <ComunaText color={theme && theme.colorTitle}>Comuna actual:</ComunaText>
            <LocalityContainer
              onClick={() => setOpenLocationModal(true)}
              className="opacity"
            >
              <div>
                <p className="locality" style={{ color:`${theme && theme.colorParagraph}` }}>{selectedLocality.name}</p>
                <p style={{ color:`${theme && theme.colorDetail}` }}>Cambiar</p>
              </div>
              <AiFillDownCircle size={26} color={theme && theme.buttonSecondaryBackground} />            
            </LocalityContainer>
          </div>
        ) : (
          <LocalityContainer
            onClick={() => setOpenLocationModal(true)}
            className="opacity"
          >
            <div>
              <p className="locality" style={{ color:`${theme && theme.colorParagraph}` }}>Sin comuna</p>
              <p  style={{ color:`${theme && theme.colorDetail}` }}>Cambiar</p>
            </div>
            <AiFillDownCircle size={26} color={theme && theme.buttonSecondaryBackground} />            
          </LocalityContainer>
        )}

        {user && user.email ? (
          <div className="row-cont">
            <Popover
              style={{ zIndex: 999 }}
              isOpen={userMenuOpen}
              position={["bottom"]}
              padding={10}
              onClickOutside={() => setUserMenuOpen(false)}
              content={({ position, targetRect, popoverRect }) => (
                <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                  position={position}
                  targetRect={targetRect}
                  popoverRect={popoverRect}
                  arrowColor={user && user.commerce ? "#fafafa" : theme && theme.bodyBackgroundDetails}
                  arrowSize={10}
                  arrowStyle={{ marginTop: 3 }}
                >
                  <UserMenuContainer
                    onClick={() => setUserMenuOpen(!userMenuOpen)}
                    bgColor={user && user.commerce ? "#fafafa" : theme && theme.bodyBackgroundDetails}
                    boxShadow={theme && theme.bodyBackgroundSecondary}
                  >
                    {user && user.commerce ? (
                      <>
                        <Link to="/store-home">
                          <p className="opacity">Mis pedidos</p>
                        </Link>
                        {/* {user && user.brand === null && (
                          <p
                            className="opacity"
                            onClick={() => dispatch(setShowManagerForm(true))}
                          >
                            Mis datos de contacto
                          </p>
                        )} */}
                        {user && user.brand === null && (
                          <Link to="/store-settings">
                            <p className="opacity">Configuración de tienda</p>
                          </Link>
                        )}
                        <p
                          className="opacity"
                          onClick={() => history.push("/change-password")}
                        >
                          Cambiar contraseña
                        </p>
                      </>
                    ) : (
                      <>
                        <p
                          className="opacity"
                          onClick={() =>
                            history.push("/profile", { query: "profile" })
                          }
                          style={{ color:`${theme && theme.colorTitle || "#3c434d"}` }}
                        >
                          Editar perfil
                        </p>

                        <p
                          className="opacity"
                          onClick={() => history.push("/change-password")}
                          style={{ color:`${theme && theme.colorTitle || "#3c434d"}` }}
                        >
                          Cambiar contraseña
                        </p>

                        <p
                          className="opacity"
                          onClick={() => history.push("/purchase-history/1")}
                          style={{ color:`${theme && theme.colorTitle || "#3c434d"}` }}
                        >
                          Historial de compra
                        </p>
                      </>
                    )}

                    <div className="divider" style={{ backgroundColor:`${theme && theme.colorTitle || "#e0e0e0"}` }} />

                    <p onClick={handleLogout} className="opacity" style={{ color:`${theme && theme.colorTitle || "#3c434d"}` }}>
                      Cerrar sesión
                    </p>
                  </UserMenuContainer>
                </ArrowContainer>
              )}
            >
              {(
                ref // if you'd like access to the ref itself for some reason, you can provide a function as a child into which the ref will be injected
              ) => (
                <div
                  role="button"
                  tabIndex="-1"
                  ref={ref}
                  onClick={() => setUserMenuOpen(true)}
                  className="row-cont opacity hidden-sm"
                >
                  <Username color={theme && theme.colorTitle}>
                    {user.name
                      ? `${user.name} ${user.surname}`
                      : user.commerce && user.commerce.name}
                    {user &&
                      user.commerce === true &&
                      user.brand &&
                      user.brand.name}
                  </Username>
                  <MdKeyboardArrowDown size={20} color={theme && theme.colorTitle || "#404040"} />
                </div>
              )}
            </Popover>
          </div>
        ) : null}
        {window.location.pathname === "/" && (!user || !user.email) ? (
          <>
            <Link to="/login" className="hidden-sm">
            <div className="opacity">
              <Button
                        margin="20px 0px 20px 0px"
                        // width="300px"
                        // maxWidth="calc(100vw - 40px)"
                        height="35px"
                        backgroundColor={theme && theme.buttonPrimaryText} // express //
                        color={theme && theme.buttonPrimaryBackgound} // express //
                        outline // express //
                        border={theme && theme.buttonPrimaryText} // express //
                      >
                        Iniciar sesión
                      </Button>
                    </div>
            </Link>
            <Link to="/register" className="hidden-sm">
                  <Button
                        margin="0px 10px"
                        // width="300px"
                        // maxWidth="calc(100vw - 40px)"
                        height="35px"
                        backgroundColor={theme && theme.buttonPrimaryBackgound} // express //
                        color={theme && theme.buttonPrimaryText} // express //
                        outline // express //
                        border={theme && theme.buttonPrimaryBackgound} // express //
                      >
                        Regístrate
                      </Button>
            </Link>
          </>
        ) : null}
        {window.location.pathname !== "/" && (!user || !user.email) ? (
          <Link to="/login" className="hidden-sm">
            <Username color={theme && theme.colorTitle}>Mi cuenta</Username>
          </Link>
        ) : null}
        {!user || !user.commerce ? (
          <CartButton
            onClick={() => {gtagCartModal(); dispatch(openCartModal(true));}}
            className="opacity"
            bgColor={theme && theme.buttonSecondaryBackground}
            bgColorBadge={theme && theme.buttonPrimaryBackgound}
            colorBadge={theme && theme.buttonPrimaryText}
          >
            <MdShoppingCart color={theme && theme.buttonSecondaryText || "#fff"} size={20} />
            {cartCount ? <div className="badge">{cartCount}</div> : null}
          </CartButton>
        ) : null}

        <MdMenu
          onClick={() => setOpenResponsiveMenu(true)}
          className="opacity hidden-md-and-up"
          size={26}
          color={theme && theme.buttonPrimaryBackgound || primaryColor}
        />
      </RightContainer>
      <CartModal />

        <Drawer
          isOpen={openResponsiveMenu}
          onClose={() => setOpenResponsiveMenu(false)}
        >
          <DrawerContainer>
            {user && user.email ? (
              <>
                {user.commerce ? (
                  <>
                    <div className="row-cont">
                      <MdList size={26} color={primaryColor} />

                      <p
                        className="opacity"
                        onClick={() => history.push("/store-home")}
                      >
                        Mis pedidos
                      </p>
                    </div>
                    <div
                      role="button"
                      tabIndex="-1"
                      onClick={() => dispatch(setShowManagerForm(true))}
                      className="row-cont"
                    >
                      <MdContactPhone size={26} color={primaryColor} />
                      <p className="opacity">Mis datos de contacto</p>
                    </div>

                    <Link to="/store-settings">
                      <div className="row-cont">
                        <MdSettings size={26} color={primaryColor} />

                        <p className="opacity">Configuración de tienda</p>
                      </div>
                    </Link>
                    <div className="row-cont">
                      <MdLockOutline size={26} color={primaryColor} />
                      <p
                        className="opacity"
                        onClick={() => history.push("/change-password")}
                      >
                        Cambiar contraseña
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="row-cont">
                      <MdPersonOutline size={26} color={theme && theme.buttonPrimaryBackgound || primaryColor} />
                      <p
                        className="opacity"
                        onClick={() =>
                          history.push("/profile", { query: "profile" })
                        }
                        style={{ color:`${theme && theme.colorTitle || "#3c434d"}` }}
                      >
                        Editar perfil
                      </p>
                    </div>
                    <div className="row-cont">
                      <MdLockOutline size={26} color={theme && theme.buttonPrimaryBackgound || primaryColor} />
                      <p
                        className="opacity"
                        onClick={() =>
                          history.push("/profile", { query: "password" })
                        }
                        style={{ color:`${theme && theme.colorTitle || "#3c434d"}` }}
                      >
                        Cambiar contraseña
                      </p>
                    </div>
                    <div className="row-cont">
                      <MdList size={26} color={theme && theme.buttonPrimaryBackgound || primaryColor} />

                      <p
                        className="opacity"
                        onClick={() => history.push("/purchase-history/1")}
                        style={{ color:`${theme && theme.colorTitle || "#3c434d"}` }}
                      >
                        Historial de compra
                      </p>
                    </div>
                    <div className="row-cont">
                      <MdLocationOn size={26} color={theme && theme.buttonPrimaryBackgound || primaryColor} />

                      <p
                        className="opacity"
                        onClick={() => {
                          setOpenResponsiveMenu(false);
                          setOpenLocationModal(true);
                        }}
                        style={{ color:`${theme && theme.colorTitle || "#3c434d"}` }}
                      >
                        Cambiar comuna
                      </p>
                    </div>
                  </>
                )}

                <div className="divider" style={{ backgroundColor:`${theme && theme.colorTitle || "#e0e0e0"}` }} />
                <div className="row-cont">
                  <MdExitToApp size={26} color={theme && theme.buttonPrimaryBackgound || primaryColor} />
                  <p onClick={handleLogout} className="opacity" style={{ color:`${theme && theme.colorTitle || "#3c434d"}` }}>
                    Cerrar sesión
                  </p>
                </div>
              </>
            ) : (
              <>
                <div className="row-cont">
                  <MdPersonOutline size={26} color={theme && theme.buttonPrimaryBackgound || primaryColor} />
                  <p className="opacity" onClick={() => history.push("/login")} style={{ color:`${theme && theme.colorTitle || "#404040"}` }}>
                    Iniciar sesion
                  </p>
                </div>
                <div className="row-cont">
                  <MdPersonAdd size={26} color={theme && theme.buttonPrimaryBackgound || primaryColor} />
                  <p
                    className="opacity"
                    onClick={() => history.push("/register")}
                    style={{ color:`${theme && theme.colorTitle || "#404040"}` }}
                  >
                    Registro
                  </p>
                </div>
                <div className="row-cont">
                  <MdStore size={26} color={theme && theme.buttonPrimaryBackgound || primaryColor} />
                  <p className="opacity" style={{ color:`${theme && theme.colorTitle || "#404040"}` }}>Tiendas</p>
                </div>
                <div className="row-cont">
                  <MdLocationOn size={26} color={theme && theme.buttonPrimaryBackgound || primaryColor} />
                  <p
                    className="opacity"
                    onClick={() => {
                      setOpenResponsiveMenu(false);
                      setOpenLocationModal(true);
                    }}
                    style={{ color:`${theme && theme.colorTitle || "#404040"}` }}
                  >
                    Cambiar comuna
                  </p>
                </div>
              </>
            )}
          </DrawerContainer>
        </Drawer>

      {user &&
      user.commerce &&
      user.roles.findIndex((item) => item === "ROLE_BRAND") === -1 ? (
        <StoreManagerForm />
      ) : null}
      <LocationModal
        open={openLocationModal}
        onClose={() => setOpenLocationModal(false)}
      />
    </Container>


    {canSearchHeader ?
        <ContainerRespo bgColor="white" height={history && history.location && history.location.pathname.includes("/catalog") ? "32px" : "40px"}>

        <WrapSearchBarRespo>
        <SearchBar bottom="0px">
          <Input
            value={searchText}
            onChange={({ target: { value } }) => setSearchText(value)} // setSearchText(value)
            placeholder="Buscar productos"
            width="100%"
            widthXs="calc(100% - 20px)"
            height="30px"
            onKeyPress={(e) => e.key==="Enter" ? handleSearch() : null}
          />
        
        </SearchBar>

        <WrapGlassSearchRespo  onClick={handleSearch} bgColor={theme && theme.buttonPrimaryBackgound}>
          <BiSearch size={20} color={theme && theme.buttonPrimaryText || "white"} className="opacity"/>        
        </WrapGlassSearchRespo>
      </WrapSearchBarRespo>

    </ContainerRespo>
      : null}


    </div>
  );
};

export default Header;

Header.propTypes = {
  canGoBack: PropTypes.bool.isRequired,
  canSearchHeader: PropTypes.bool,
  idStoreDetail: PropTypes.string,
  catCatView: PropTypes.string,
  subCatCatView: PropTypes.string,
  famCatView: PropTypes.string,
  marginTopHeader: PropTypes.string,
};

Header.defaultProps = {
  canSearchHeader: false,
  idStoreDetail: null,
  catCatView: null,
  subCatCatView: null,
  famCatView: null,
  marginTopHeader: null,
};
